import { ChosenProductType } from "../../../modals/modalsUtils";
import { StorageProductRelationHistoryProxy } from "@me-team/host/main/graphql/types";
import { SellProductForm } from "../../types";
import { DeepPartial } from "../../../../../interfaces/interfaces";

type GetUpdatedFormValuesParams = {
    action: "create" | "update";
    bookingUuid?: string;
    currentDateTime: string;
    chosenProduct?: ChosenProductType;
    saleOperationEntity?: DeepPartial<StorageProductRelationHistoryProxy>;
};

type PartialSaleHistory = DeepPartial<StorageProductRelationHistoryProxy["relatedSaleHistories"][number]>;

const defaultProductInput: SellProductForm["productsInput"][0] = {
    product: null,
    warehouse: null,
    quantity: 1,
    unit: null,
    price: null,
    amount: null,
    discount: null,
    isAmountManuallyEdited: false,
    storageProductRelationId: null,
    storageProductRelationHistoryId: null,
};

export const getUpdatedFormValues = (
    prevValues: SellProductForm,
    { action, bookingUuid, currentDateTime, chosenProduct, saleOperationEntity }: GetUpdatedFormValuesParams
): SellProductForm => {
    const mapHistories = (histories: PartialSaleHistory[]) =>
        histories.map((history) => ({
            product: history.product?.id ?? null,
            warehouse: history.storage?.id ?? null,
            quantity: history.operationQuantity ?? 1,
            unit: history.operationUnit?.id ?? null,
            price: Number(history.price) ?? null,
            amount: Number(history.amount) ?? null,
            discount: history.discount ?? null,
            isAmountManuallyEdited: false,
            storageProductRelationId: null,
            storageProductRelationHistoryId: history.id ?? null,
        }));

    if (action === "update" && bookingUuid && saleOperationEntity) {
        return {
            ...prevValues,
            dateTime: saleOperationEntity.date ?? prevValues.dateTime,
            isPaid: saleOperationEntity.isPaid ?? prevValues.isPaid,
            paymentType: saleOperationEntity.paymentType ?? prevValues.paymentType,
            comment: saleOperationEntity.comment ?? prevValues.comment,
            productsInput: saleOperationEntity.relatedSaleHistories?.length
                ? mapHistories(saleOperationEntity.relatedSaleHistories)
                : [defaultProductInput],
            operationNumber: saleOperationEntity.operationNumber,
        };
    }

    if (action === "update" && !bookingUuid) {
        return {
            ...prevValues,
            dateTime: chosenProduct?.date ?? prevValues.dateTime,
            isPaid: chosenProduct?.isPaid ?? prevValues.isPaid,
            paymentType: chosenProduct?.paymentType ?? prevValues.paymentType,
            comment: chosenProduct?.comment ?? prevValues.comment,
            productsInput: chosenProduct?.relatedSaleHistories?.length
                ? mapHistories(chosenProduct.relatedSaleHistories)
                : [defaultProductInput],
            operationNumber: chosenProduct?.operationNumber && prevValues.operationNumber,
        };
    }

    if (action === "create") {
        return {
            ...prevValues,
            dateTime: bookingUuid ? prevValues.dateTime : currentDateTime,
            isPaid: false,
            paymentType: null,
            comment: "",
            productsInput: [defaultProductInput],
        };
    }

    return prevValues;
};
